import { useState, useEffect } from "react";

import { Autocomplete, createFilterOptions } from "@mui/material";
import { getThailandAddress } from "src/api/static";

const AddressAutocomplete = ({ value = null, onChange, renderInput }) => {
  const [addressOptions, setAddressOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAddress = async () => {
    setIsLoading(true);

    let results = await getThailandAddress();

    setAddressOptions(results);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchAddress();
  }, []);

  return (
    <Autocomplete
      value={value}
      loading={isLoading}
      options={addressOptions}
      getOptionLabel={(option) =>
        `${option.subdistrict}, ${option.district}, ${option.province}, ${option.zipcode}`
      }
      isOptionEqualToValue={(option, value) =>
        option.subdistrict === value.subdistrict &&
        option.district === value.district &&
        option.province === value.province &&
        option.zipcode === value.zipcode
      }
      renderOption={(props, option) => (
        <li {...props}>
          {`${option.subdistrict} » ${option.district} » ${option.province} » ${option.zipcode}`}
        </li>
      )}
      renderInput={(params) => renderInput(params)}
      onChange={(e, value) => onChange(value)}
      filterOptions={createFilterOptions({
        matchFrom: "any",
        limit: 100,
      })}
      sx={{ width: "100%" }}
    />
  );
};

export default AddressAutocomplete;
